// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-in-page {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  overflow: hidden;
  background: radial-gradient(circle at 10% 10%, rgba(22, 119, 255, 0.16), transparent 38%), radial-gradient(circle at 90% 0%, rgba(74, 144, 226, 0.12), transparent 42%), linear-gradient(160deg, #f7faff 0%, #eef4ff 58%, #f9fbff 100%);
  border-radius: 24px;
}

.sign-in-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: inherit;
  background: inherit;
}

.sign-in-page__panel {
  position: relative;
  z-index: 1;
  width: min(520px, 100%);
  border: 1px solid #d6e4ff;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.14);
  padding: 28px 28px 24px;
}

.sign-in-page__lang {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.sign-in-page__header {
  margin-bottom: 18px;
  text-align: center;
}

.sign-in-page__eyebrow {
  margin: 0 0 6px;
  color: #4f6f9b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.sign-in-page__title {
  margin: 0;
  color: #111827;
  font-size: 34px;
  line-height: 1.15;
}

@media screen and (max-width: 575px) {
  .sign-in-page {
    min-height: 100vh;
    padding: 20px 10px;
  }
  .sign-in-page__panel {
    border-radius: 18px;
    padding: 20px 16px;
  }
  .sign-in-page__title {
    font-size: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/signInPage/SignInPage.sass"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uOAAA;EACA,mBAAA;AACF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,uBAAA;AAGF;;AADA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,mBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAMF;;AAJA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAOF;;AALA;EACE;IACE,iBAAA;IACA,kBAAA;EAQF;EANA;IACE,mBAAA;IACA,kBAAA;EAQF;EANA;IACE,eAAA;EAQF;AACF","sourcesContent":[".sign-in-page\n  position: relative\n  width: 100%\n  box-sizing: border-box\n  min-height: 100vh\n  display: flex\n  align-items: center\n  justify-content: center\n  padding: 32px 16px\n  overflow: hidden\n  background: radial-gradient(circle at 10% 10%, rgba(22, 119, 255, 0.16), transparent 38%), radial-gradient(circle at 90% 0%, rgba(74, 144, 226, 0.12), transparent 42%), linear-gradient(160deg, #f7faff 0%, #eef4ff 58%, #f9fbff 100%)\n  border-radius: 24px\n\n.sign-in-page::before\n  content: \"\"\n  position: absolute\n  inset: 0\n  z-index: 0\n  border-radius: inherit\n  background: inherit\n\n.sign-in-page__panel\n  position: relative\n  z-index: 1\n  width: min(520px, 100%)\n  border: 1px solid #d6e4ff\n  border-radius: 22px\n  background: #ffffff\n  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.14)\n  padding: 28px 28px 24px\n\n.sign-in-page__lang\n  display: flex\n  justify-content: flex-end\n  margin-bottom: 14px\n\n.sign-in-page__header\n  margin-bottom: 18px\n  text-align: center\n\n.sign-in-page__eyebrow\n  margin: 0 0 6px\n  color: #4f6f9b\n  font-size: 12px\n  font-weight: 700\n  letter-spacing: 0.1em\n  text-transform: uppercase\n\n.sign-in-page__title\n  margin: 0\n  color: #111827\n  font-size: 34px\n  line-height: 1.15\n\n@media screen and (max-width: 575px)\n  .sign-in-page\n    min-height: 100vh\n    padding: 20px 10px\n\n  .sign-in-page__panel\n    border-radius: 18px\n    padding: 20px 16px\n\n  .sign-in-page__title\n    font-size: 28px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
